import { reatomAsync } from "@reatom/async";
import { API } from "src/api";
import { toastHandler } from "src/util";

import { getUserApiTokens } from "./getUserApiKeys";

export const createUserApiToken = reatomAsync(
  () => API.tokenApi.apiTokenControllerCreateApiToken(),
  "createUserApiToken",
);

createUserApiToken.onFulfill.onCall((ctx) => {
  toastHandler.success({
    title: "Ключ создан!",
    name: "keycreated",
  });
  getUserApiTokens(ctx);
});
